import React from "react";
import ReactMarkdown from "react-markdown"
import { RichTextWrapper } from "../../components/article-content/article-content-elements"
import styled from "styled-components"
import { TextSectionWrapper } from "./text-section-elements"
import rehypeRaw from "rehype-raw"
import { addedClasses } from "../../helpers/markdown/addedClasses"

interface TextSectionProps {
  locale?: string
  data: {
    content: string
  },
}

export default function TextSection({data}: TextSectionProps) {
  return <TextSectionWrapper>
    <RichTextWrapper>
      {/* @ts-ignore */}
      <ReactMarkdown rehypePlugins={[rehypeRaw, addedClasses]}>{data.content}</ReactMarkdown>
    </RichTextWrapper>
  </TextSectionWrapper>;
}
